import styled from '@emotion/styled';
import { css } from '@emotion/react';

import theme from 'styles/theme';

export type ModalSize = 'sm' | 'md' | 'lg';

type PanelProps = {
  $size: ModalSize;
};

const sizeStyles: Record<ModalSize, ReturnType<typeof css>> = {
  sm: css`
    width: min(100%, 420px);
  `,
  md: css`
    width: min(100%, 520px);
  `,
  lg: css`
    width: min(100%, 720px);
  `,
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
`;

export const Panel = styled('div', {
  shouldForwardProp: (prop) => prop !== '$size',
})<PanelProps>`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
  overflow: hidden;

  ${({ $size }) => sizeStyles[$size]}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: ${theme.colors.black};
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: ${theme.colors.gray};
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: #f3f3f3;
    color: ${theme.colors.black};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const Body = styled.div`
  padding: 16px 24px 24px;
  overflow: auto;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 24px 24px;
`;
